var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-container p-10" }, [
    _c(
      "div",
      [
        !_vm.isLoggedIn
          ? _c(
              "div",
              [
                _c("h1", [_vm._v(_vm._s(_vm.$t("welcomeLogin")))]),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.onLogin } }, [
                  _vm._v("Log in")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(_vm.currentRole, { tag: "component" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }